import React from 'react'
import { Form } from 'semantic-ui-react'
import styled from 'styled-components';


const StyledForm = styled(Form)`

  &.ui.form {
    font-size: 14px;
  }
  
  
  &.ui.form .field {
    margin: 0 0 24px;
  }
  
  &.ui.form .field > label {
    font-weight: bold;
    font-size: 12px;
    color: #868686;
    letter-spacing: 0.2px;
    line-height: 12px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }
  
  &.ui.form input:not([type]), 
  &.ui.form input[type="date"], 
  &.ui.form input[type="datetime-local"], 
  &.ui.form input[type="email"], 
  &.ui.form input[type="number"], 
  &.ui.form input[type="password"], 
  &.ui.form input[type="search"], 
  &.ui.form input[type="tel"], 
  &.ui.form input[type="time"], 
  &.ui.form input[type="text"], 
  &.ui.form input[type="file"], 
  &.ui.form input[type="url"] {
    padding: 1em;
  }
  
  .ui.selection.dropdown {
    min-height: 3.358em;
    padding: 1.05em 2.1em 1.05em 1em;
  }
`;

export default StyledForm